import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11cfe6da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "companion-tuto" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "action-confirmed"
}
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "action-confirmed" }

import { computed, watch, ref } from 'vue';
import { useI18n } from 'vue-i18n'

import Delay from '@/core/Delay';

import { useAppState, useGameState } from '@/services/composition';

import UIPanel from '@/components/UIPanel/UIPanel.vue';
import UIGuide from '@/components/UIGuide/UIGuide.vue';
import UIEmojis from '@/components/UIEmojis/UIEmojis.vue';
import UIBannerInstructions from '@/components/UIBannerInstructions/UIBannerInstructions.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n()
const {send} = useAppState()
const state = useGameState()

const stateEvent = computed(()=>{
  return state?.value.event
})

watch(stateEvent, (stateEvent) => {
  if ( stateEvent.type === 'GAME_SEND_EMOJI') {
    updateEmojis()
  }
})

const emojis = ref([])
const updateEmojis = () => {
  if (state.value.context.emojis.length === emojis.value.length) return

  for (let i = 0; i < state.value.context.emojis.length - emojis.value.length; i++) {
    emojis.value.push(i)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_ui_btn = _resolveComponent("ui-btn")!
  const _component_ui_icon = _resolveComponent("ui-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "medium-fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_unref(state).matches('tuto.companion.contact'))
          ? (_openBlock(), _createBlock(UIPanel, { key: "tuto.companion.contact" }, {
              heading: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('tuto.companion.contact.title')), 1)
              ]),
              body: _withCtx(() => [
                _createElementVNode("p", {
                  class: "text-body",
                  innerHTML: _unref(t)('tuto.companion.contact.description')
                }, null, 8, _hoisted_3)
              ]),
              actions: _withCtx(() => [
                _createVNode(_Transition, {
                  name: "medium-fade",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_unref(state).matches('tuto.companion.contact.initial'))
                      ? (_openBlock(), _createBlock(_component_ui_btn, {
                          key: 0,
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(send)('GAME_ACTION_DONE')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('tuto.companion.contact.button.initial')), 1)
                          ]),
                          _: 1
                        }))
                      : (_unref(state).matches('tuto.companion.contact.sent'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createTextVNode(_toDisplayString(_unref(t)('tuto.companion.contact.button.sent')) + " ", 1),
                            _createElementVNode("div", null, [
                              _createVNode(_component_ui_icon, { name: "checkmark" })
                            ])
                          ]))
                        : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_unref(state).matches('tuto.companion.plan'))
            ? (_openBlock(), _createBlock(UIGuide, {
                key: "tuto.companion.plan",
                class: "guide--companion-plan"
              }, {
                heading: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('tuto.companion.plan')), 1)
                ]),
                _: 1
              }))
            : (_unref(state).matches('tuto.companion.teammate'))
              ? (_openBlock(), _createBlock(UIGuide, {
                  key: "tuto.companion.teammate",
                  class: "guide--companion-teammate"
                }, {
                  heading: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('tuto.companion.teammate')), 1)
                  ]),
                  _: 1
                }))
              : (_unref(state).matches('tuto.companion') && !_unref(state).matches('tuto.xr.exit_room') && _unref(state).context.advisedHotspots.length >= 1)
                ? (_openBlock(), _createBlock(UIPanel, {
                    class: "panel--completed",
                    key: "tuto.companion.completed"
                  }, {
                    heading: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('tuto.companion.completed.title')), 1)
                    ]),
                    actions: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('tuto.companion.completed.action')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(UIEmojis, { emojis: emojis.value }, null, 8, ["emojis"])
  ]))
}
}

})